import {
  FieldGuessDto,
  GuessState,
  ObjectDto,
  ObjectWithFieldsDto,
} from "../../api-client";
import { UniqueId } from "../UniqueId";
import { DEFAULT_OBJECT_IMAGE } from "../constants/constants";
import { GameObjectState } from "../states/GamePageStates/GameObjectState";
import { GameObjectValue } from "../states/GamePageStates/GameObjectValue";
import { GameAnswerState } from "../states/GamePageStates/GameAnswerState";
import { AnswerStatus } from "../enums/AnswerStatus";
import { PropertiesMapper } from "./PropertiesMapper";
import { GamePropertyState } from "../states/GamePageStates/GamePropertyState";

export class GameObjectMapper {
  public static toGameObjectValues(
    fieldValueDtos: FieldGuessDto[],
    properties: GamePropertyState[]
  ): GameObjectValue[] {
    return properties.map((property) => {
      const currentFieldValueDto = fieldValueDtos.filter(
        (fieldValueDto) => fieldValueDto.id === property.apiId
      )[0];

      return {
        answerStatus: this.toAnswerStatus(currentFieldValueDto.guessState!),
        type: PropertiesMapper.toPropertyType(currentFieldValueDto.type!),
        value: currentFieldValueDto.value,
      };
    });
  }

  public static toGameAnswerState(
    gameObjectState: GameObjectState,
    fieldGuessDtos: FieldGuessDto[],
    properties: GamePropertyState[],
    isFullGuessed: boolean
  ): GameAnswerState {
    return {
      id: UniqueId.generateUniqueId(),
      isFullGuessed: isFullGuessed,
      name: gameObjectState.name,
      image: gameObjectState.image,
      gameObjectValues: this.toGameObjectValues(fieldGuessDtos, properties),
    };
  }

  public static toGameObjectState(objectDto: ObjectDto): GameObjectState {
    return {
      id: UniqueId.generateUniqueId(),
      apiId: objectDto.id!,
      name: objectDto.name ? objectDto.name : "Объект",
      image: objectDto.thumbnail ? objectDto.thumbnail : DEFAULT_OBJECT_IMAGE,
      isTried: false,
    };
  }

  public static toGameObjectStates(
    objectDtos: ObjectWithFieldsDto[]
  ): GameObjectState[] {
    return objectDtos.map((objectDto) => {
      return {
        id: UniqueId.generateUniqueId(),
        apiId: objectDto.id!,
        name: objectDto.name ? objectDto.name : "Объект",
        image: objectDto.thumbnail ? objectDto.thumbnail : DEFAULT_OBJECT_IMAGE,
        isTried: false,
      };
    });
  }

  public static toAnswerStatus(guessState: GuessState): AnswerStatus {
    switch (guessState) {
      case 0:
        return AnswerStatus.Wrong;
      case 1:
        return AnswerStatus.Correct;
      case 2:
        return AnswerStatus.PartiallyCorrect;
      case 3:
        return AnswerStatus.WrongMore;
      case 4:
        return AnswerStatus.WrongLess;
      default:
        return AnswerStatus.Wrong;
    }
  }

  public static toGuessState(answerStatus: AnswerStatus): GuessState {
    switch (answerStatus) {
      case AnswerStatus.Wrong:
        return 0;
      case AnswerStatus.Correct:
        return 1;
      case AnswerStatus.PartiallyCorrect:
        return 2;
      case AnswerStatus.WrongLess:
        return 4;
      case AnswerStatus.WrongMore:
        return 3;
    }
  }
}
